<template>
  <minimal-layout>
    <div id="dropdown" />
    <div class="admin-panel flex h-screen bg-gray-50">

      <!-- Left Sidebar -->
      <aside class="w-64 h-screen shrink-0 bg-infertility-clinic-admin shadow-lg sticky top-0">
        <div class="flex h-full flex-col">

          <!-- Logo/Brand -->
          <div class="flex min-h-12 shrink-0 items-center justify-center border-b px-4 py-4" style="border-color: #6b1235;">
            <h2 class="text-xl font-bold text-white">
              Klinika Leczenia Niepłodności
            </h2>
          </div>

          <!-- Navigation -->
          <div class="min-h-0 flex-1 overflow-y-auto">
            <AdminInfertilityTreatmentClinicNavigation />
          </div>
        </div>
      </aside>

      <!-- Main Content Area -->
      <div class="flex flex-1 flex-col overflow-hidden">

        <!-- Top Bar -->
        <header class="border-b border-gray-200 bg-white shadow-sm">
          <div class="standard-admin-header-bar">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <h1 class="text-lg font-semibold text-gray-900">
                  Strona kliniki
                </h1>
              </div>
              <div class="flex items-center space-x-4">
                <div class="text-sm text-gray-600">
                  {{ $page.props.auth.user.first_name }}
                  <span class="hidden md:inline">{{
                    $page.props.auth.user.last_name
                  }}</span>
                </div>
                <button
                  type="button"
                  class="btn-indigo-sm"
                  @click="logout"
                >
                  Wyloguj
                </button>
              </div>
            </div>
          </div>
        </header>

        <!-- Page Content -->
        <main class="flex-1 overflow-y-auto bg-gray-50">
          <div class="standard-admin-content-viewport">
            <flash-messages />
            <slot />
          </div>
        </main>
      </div>
    </div>
  </minimal-layout>
</template>

<script>
import MinimalLayout from '@/Layouts/Minimal.vue';
import FlashMessages from '@/Shared/FlashMessages.vue';
import AdminInfertilityTreatmentClinicNavigation from '@/Components/AdminInfertilityTreatmentClinicNavigation.vue';

export default {
  components: {
    MinimalLayout,
    FlashMessages,
    AdminInfertilityTreatmentClinicNavigation,
  },
  methods: {
    logout() {
      this.$inertia.delete(this.$routes.destroy_user_session());
    },
  },
};
</script>
